import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent {
  Id!: number;
  error500: boolean;
  error403: boolean;
  error401: boolean;
  error404: boolean;
  error400: boolean;
  internalError: boolean;
  constructor(
    private activatedRouter: ActivatedRoute,
    private router: Router
  ) {
    this.error500 = window.location.pathname.includes('/error-status-500')
    this.error403 = window.location.pathname.includes('/error-status-403')
    this.error401 = window.location.pathname.includes('/error-status-401')
    this.error400 = window.location.pathname.includes('/error-status-400')
    this.error404 = window.location.pathname.includes('/error-status-404')
    this.internalError = window.location.pathname.includes('/internal-error')
    this.activatedRouter.params.subscribe((val) => {
      this.Id = val['id'];
    });
  }

  goback() {
    this.router.navigate(['/quotation/get-quote']);
  }

  login() {
    const redirectUrl = environment.uatLoginCommonUrl+'auth/login?redirect_url=' +
      encodeURIComponent(`${environment.siteBaseUrl}dashboard`)+
      '&orgAppId=6120';
    window.location.href = redirectUrl;
  }
}
